<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center px-3 py-4 rounded-md mx-auto"
    style="max-width: 75%;min-height: 75vh;"
  >
    <div class="d-flex flex-column align-items-center justify-content-center">
      <img
        src="@/assets/img/general/letter.svg"
        alt="logo"
        class="img-fluid"
        style="max-height: 12rem"
      />
    </div>

    <div class="mt-4 mx-auto w-100">
      <!-- Confirm the unsubscription -->
      <div class="text-center">
        <h2 class="fs-4 fw-bold ">{{ $t("Unsubscribe") }}</h2>
        <p class=" fs-6 mt-2 mb-4 fw-semibold">
          {{ $t("Are you sure you want to unsubscribe?") }}
        </p>
        <button @click="onUnsubscribe" class="btn btn-danger w-100" :disabled="loading">
          <span v-if="loading">
            <i class="fas fa-spinner fa-spin me-2"></i>
            {{ $t("Unsubscribing") }}...
          </span>
          <span v-else>
            {{ $t("Unsubscribe") }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useAuthStore } from "@/store/auth";
import helpers from "@/helpers";

export default {
  name: "UnsubscribeView",
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions(useAuthStore, ["unsubscribe"]),
    async onUnsubscribe() {
      this.loading = true;
      try {
        await this.unsubscribe();
        helpers.showToast(
          this.$t("Unsubscribed completed successfully"),
          this.$t("Unsubscribed"),
          "success"
        );
        this.$router.push("/");
      } catch (error) {
        console.error("Unsubscribe failed:", error);
        helpers.showToast(
          this.$t("Failed to unsubscribe, please try again"),
          this.$t("Unsubscribe failed"),
          "error"
        );
      } finally {
        this.loading = false;
      }

    },
  },
};
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 10vh;
  height: 50vh;
}
.not-found h1 {
  font-size: 6rem;
  color: #ff4040;
}
.not-found p {
  font-size: 1.5rem;
  margin: 1rem 0;
}
</style>
